import React from 'react';
import { Modal, Button, Row, Col, Table } from 'react-bootstrap';
import * as moment from 'moment';
import { DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT, loaiTuyenSinhValue, objectLoaiTuyenSinh, trangThaiDotTuyenSinhValue, objectTrangThaiDotTuyenSinh, doiTuongValue, objectDoiTuong } from '../../../../../utils/define';
import { parseDoiTuongMienGiam } from '../dotTuyenSinh/DoiTuongMienGiamFields';
import { BaseGatewayImage } from '@app/utils/apiUrl';

const ChiTietLopDaoTaoThucHanhModal = ({ isOpen, onClose, data, getChucDanhName }) => {
    if (!data) return null;

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    const chucDanhName = getChucDanhName(data.chucDanhIds) || '';
    const chucDanhList = chucDanhName
        .split(',')
        .map(s => s
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/đ/g, 'd')
            .replace(/Đ/g, 'D')
            .trim()
            .toLowerCase());

    const isBacSi = chucDanhList.includes('bac si');
    const isYSi = chucDanhList.includes('y si');
    const isDieuDuong = chucDanhList.includes('dieu duong');
    const isKTV = chucDanhList.includes('ky thuat vien');
    const isDinhDuongLamSang = chucDanhList.includes('dinh duong lam sang');

    return (
        <Modal
            show={isOpen}
            onHide={onClose}
            size="xl"
            backdrop="static"
            keyboard={false}
            centered
            style={{ zIndex: '9999' }}
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-primary font-weight-bold">Chi tiết Tuyển sinh Đào tạo thực hành</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                <h5 className="text-info mb-3 border-bottom pb-2">Thông tin chung</h5>
                <Row className="mb-3">
                    <Col md={6}>
                        <p><strong>Tên khóa học:</strong> <span className="text-danger">{data.tenKhoaHoc}</span></p>
                        <p><strong>Loại tuyển sinh:</strong> <span className="badge badge-success">{getLabelFromEnum(data.loaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue)}</span></p>
                        <p><strong>Trạng thái:</strong> <span className="badge badge-primary">{getLabelFromEnum(data.trangThaiDotTuyenSinh, objectTrangThaiDotTuyenSinh, trangThaiDotTuyenSinhValue)}</span></p>
                        <p><strong>Đối tượng:</strong> {getLabelFromEnum(data.doiTuongEnum, objectDoiTuong, doiTuongValue)}</p>
                        <p><strong>Chức danh:</strong> {chucDanhName}</p>
                        <p><strong>Đối tượng miễn giảm:</strong> {parseDoiTuongMienGiam(data.doiTuongMienGiam).map(x => x.tenDoiTuong).join(', ') || 'Không có'}</p>
                        <div className="mb-2 d-flex align-items-center">
                            <strong className="mr-2">File đính kèm:</strong> 
                            {data.fileDinhKem ? (
                                (() => {
                                    const path = data.fileDinhKem;
                                    const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
                                    const safePath = path.startsWith('/') ? path : `/${path}`;
                                    const fileUrl = path.startsWith('http') ? path : `${baseUrl}${safePath}`;
                                    let name = path.split('/').pop() || 'File';
                                    name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                                    return (
                                        <a href={fileUrl} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm text-left" style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                            <i className="fas fa-paperclip mr-1"></i> {name}
                                        </a>
                                    );
                                })()
                            ) : (
                                <span className="text-muted">Không có</span>
                            )}
                        </div>
                    </Col>
                    <Col md={6}>
                        <p><strong>Ngày khai giảng:</strong> {data.ngayKhaiGiang ? moment(data.ngayKhaiGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                        <p><strong>Ngày bắt đầu nhận hồ sơ:</strong> {data.ngayBatDauNhanHoSo ? moment(data.ngayBatDauNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                        <p><strong>Ngày kết thúc nhận hồ sơ:</strong> {data.ngayKetThucNhanHoSo ? moment(data.ngayKetThucNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                    </Col>
                </Row>

                {(isBacSi || isYSi || isDieuDuong || isKTV || isDinhDuongLamSang) && (
                    <>
                        <h5 className="text-info mb-3 border-bottom pb-2">Thời gian & Học phí theo đối tượng</h5>
                        <div className="table-responsive mb-3">
                            <Table bordered hover size="sm" className="text-center">
                                <thead className="bg-light">
                                    <tr>
                                        <th>Đối tượng</th>
                                        <th>Thời gian (Tháng)</th>
                                        <th>Học phí (VNĐ)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isBacSi && (
                                    <tr>
                                        <td className="font-weight-bold text-left">Bác sĩ</td>
                                        <td>{data.thoiGianBacSi || '-'}</td>
                                        <td className="text-right text-danger">{data.hocPhiBacSi != null ? new Intl.NumberFormat('vi-VN').format(data.hocPhiBacSi) : '-'}</td>
                                    </tr>
                                    )}
                                    {isYSi && (
                                    <tr>
                                        <td className="font-weight-bold text-left">Y sĩ</td>
                                        <td>{data.thoiGianYSi || '-'}</td>
                                        <td className="text-right text-danger">{data.hocPhiYSi != null ? new Intl.NumberFormat('vi-VN').format(data.hocPhiYSi) : '-'}</td>
                                    </tr>
                                    )}
                                    {isDieuDuong && (
                                    <tr>
                                        <td className="font-weight-bold text-left">Điều dưỡng</td>
                                        <td>{data.thoiGianDieuDuong || '-'}</td>
                                        <td className="text-right text-danger">{data.hocPhiDieuDuong != null ? new Intl.NumberFormat('vi-VN').format(data.hocPhiDieuDuong) : '-'}</td>
                                    </tr>
                                    )}
                                    {isKTV && (
                                    <tr>
                                        <td className="font-weight-bold text-left">Kỹ thuật viên</td>
                                        <td>{data.thoiGianKTV || '-'}</td>
                                        <td className="text-right text-danger">{data.hocPhiKTV != null ? new Intl.NumberFormat('vi-VN').format(data.hocPhiKTV) : '-'}</td>
                                    </tr>
                                    )}
                                    {isDinhDuongLamSang && (
                                    <tr>
                                        <td className="font-weight-bold text-left">Dinh dưỡng lâm sàng</td>
                                        <td>{data.thoiGianDinhDuongLamSang || '-'}</td>
                                        <td className="text-right text-danger">{data.hocPhiDinhDuongLamSang != null ? new Intl.NumberFormat('vi-VN').format(data.hocPhiDinhDuongLamSang) : '-'}</td>
                                    </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </>
                )}

                <h5 className="text-info mb-3 border-bottom pb-2">Nội dung chi tiết</h5>
                <div className="mb-3">
                    <strong>Nội dung khóa học:</strong>
                    <div 
                        className="p-3 bg-light rounded mt-2" 
                        dangerouslySetInnerHTML={{ __html: data.noiDungKhoaHoc || '<i>Chưa cập nhật</i>' }} 
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ChiTietLopDaoTaoThucHanhModal;
